/**
 * A per-document counter the chat bumps when it leaves an editor note.
 *
 * Marks load when a document opens and after the writer's own changes; a note
 * the AI makes mid-conversation arrives from the server, so the editor has to be
 * told. The `study.revisionNotesChanged` UI intent bumps this counter, and
 * {@link useRefetchOnNotesSignal} refetches when its document's counter moves.
 */
import { create } from 'zustand';

interface EditorNotesSignal {
  /** How many note changes each document has seen this session. */
  versions: Record<string, number>;
  /** Record a note change on `documentId`. */
  bump: (documentId: string) => void;
}

export const useEditorNotesSignal = create<EditorNotesSignal>(set => ({
  versions: {},
  bump: documentId =>
    set(state => ({
      versions: { ...state.versions, [documentId]: (state.versions[documentId] ?? 0) + 1 },
    })),
}));
